import { render, staticRenderFns } from "./amountTab.vue?vue&type=template&id=5e5cc453&"
import script from "./amountTab.vue?vue&type=script&lang=js&"
export * from "./amountTab.vue?vue&type=script&lang=js&"
import style0 from "./amountTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports